import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { AmountPipe } from '../../../payments/payment/pipes';
import { DonationsExposedService } from '../../data-access/donations-exposed.service';
import { DonationSubscriptionStateConfirmationComponent } from '../donation-subscription-state-confirmation/donation-subscription-state-confirmation.component';
import { catchError, mergeMap, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'equine-ui-nx-donations-detail-dialog',
  standalone: true,
  imports: [
    MatTableModule,
    MatIcon,
    CommonModule,
    MatButton,
    AmountPipe,
    MatDialogContent,
    MatDialogActions
  ],
  providers: [
    DonationsExposedService
  ],
  templateUrl: './donations-detail-dialog.component.html',
  styleUrl: './donations-detail-dialog.component.scss',
})
export class DonationsDetailDialogComponent implements OnInit, OnDestroy {
  displayedColumns = ['id', 'date', 'amount'];

  unsubscribe$ = new Subject<void>();
  hasChangedState = false;
  subscription: any;
  
  constructor(
    public dialogRef: MatDialogRef<DonationsDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {donationId: string, payments: any[], userId: string, subscription: any},
    private donationsExposedService: DonationsExposedService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscription = this.data.subscription;
  }

  pauseSubscription() {
    this.openConfirmationDialog('SUSPEND', 'Pause');
  }

  cancelSubscription() {
    this.openConfirmationDialog('CANCEL', 'Cancel');
  }

  activateSubscription() {
    this.openConfirmationDialog('ACTIVATE', 'Activate');
  }

  openConfirmationDialog(action: string, label: string) {
    this.dialog.open(DonationSubscriptionStateConfirmationComponent, {data: {label}}).afterClosed()
    .pipe(
      takeUntil(this.unsubscribe$)
    )
    .subscribe({
      next: (execute: boolean) => {
        if (execute) {
          this.donationsExposedService.changeSubscriptionState(action, this.data.donationId, `Requested by ${this.data.userId} [${new Date()}]`)
            .pipe(
              takeUntil(this.unsubscribe$),
              mergeMap(() => this.donationsExposedService.getDonationById(this.subscription._id)),
              catchError((error: any) => {
                return {hasError: true, ...error};
              })
            )
            .subscribe({
              next: (response: any) => {
                if (response.hasError) {
                  return;
                }
                this.subscription = response;
              }
            })
        }
      }
    })
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
